import React, {useState} from "react";
import {Box, Column, Columns, Pagination, Table, Title} from "@allxsmith/bestax-bulma";
import {useVehiclesData} from "../../../hooks/useVehiclesData";
import {getVehiclesData} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import ExternalVehicleRow from "./VehicleRow";
import {useDispatch, useSelector} from "react-redux";
import FilterBlankHeading from "../../Invoicing/FilterBlankHeading";
import FilterHeading from "../../Invoicing/FilterHeading";
import axios from "axios";
import {createSetDataFreshAction, createSetVehiclesDataAction} from "../../../actions/dataActions";
import {ToastContainer,  toast} from "react-toastify";
import PaginationWrapper from "../../Utils/PaginationWrapper";


export default function ExternalVehicleView(props){
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState({});
    const dispatch = useDispatch();

    let params = {
        page: page,
        view: "JOB",
        keys: true
    };

    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }

    const loading = useVehiclesData(params, props.dataFresh);
    const data = useSelector(getVehiclesData);


    const headings = [
        {
            label: "Registration",
            field: "registration",
            labelField: "registration"
        },
        {
            label: "Make"
        },
        {
            label: "Model"
        },
        {
            label: "Key Number"
        },
        {
            label: "Owner",
            field: "owner",
            labelField: "owner__display_name"
        },
        {
            label: "Hirer",
            field: "hire_customer",
            labelField: "hire_customer__display_name"
        },
        {
            label: "Status"
        },
        {
            label: "Comments"
        },
        {
            label: "Stored"
        },
        {
            label: ""
        },
        {
            label: ""
        }
    ];

    const onCollected = data => {
        const conf = {
            url: "api/job/vehiclecomplete",
            data: data,
            method: "put"
        };
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(props.dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error or the vehicle is not ready for collection", {position: "top-right"})
        })
    }

    const onChange = (e, index) => {
        let newVehicles = {...data};
        newVehicles.results[index][e.target.name] = e.target.value;
        dispatch(createSetVehiclesDataAction(newVehicles));
    }

    const onSave = data => {
        const conf = {
            url: `/api/vehicles/${data.id}`,
            method: "put",
            data: data
        };
        return axios(conf).then(res => {
            dispatch(createSetDataFreshAction(props.dataFresh + 1));
        }).catch(err => {
            NotificationManager.error("There was an error")
        })
    }


    const onKeyUnassign = (data) => {
        const conf = {
            url: "api/vehicles/clearkey",
            data: {vehicle: data},
            method: "put"
        };
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(props.dataFresh + 1));
        })
    }

    if(!loading){
        return <LoadingSpinner/>
    }

    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <Box>
            <details>
                <summary><Title>{`External Customer Vehicles With Keys (${data ? data.count : 0})`}</Title></summary>/
                <Columns isMultiline>
                    <Column>
                        <Table isFullwidth>
                            <thead>
                                <tr className={"small-row-black"}>
                                    {headings.map(heading => {
                                        if (!heading.field) {
                                          return <th key={heading.label} className={heading.className || ""}>{heading.label}</th>;
                                        }
                                        if (heading.blank) {
                                          return (
                                            <FilterBlankHeading
                                              key={heading.label}
                                              heading={heading}
                                              setFilters={f => {
                                                setPage(1);
                                                setFilters(f);
                                              }}
                                              filters={filters}
                                              className={heading.className}
                                              thClass={heading.thClass}
                                            />
                                          );
                                        }
                                        return (
                                          <FilterHeading
                                            key={heading.label}
                                            heading={heading}
                                            setFilters={f => {
                                              setPage(1);
                                              setFilters(f);
                                            }}
                                            filters={filters}
                                            options={data ? data.filter_list[heading.field] : []}
                                            className={heading.className}
                                            thClass={heading.thClass}
                                          />
                                        );
                                      })}
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.results.map((vehicle, index) => (
                                    <ExternalVehicleRow
                                        data={vehicle}
                                        index={index}
                                        onKeyUnassign={onKeyUnassign}
                                        onVehicleCollected={onCollected}
                                        onChange={onChange}
                                        onSave={onSave}
                                        key={vehicle.id}
                                    />
                                ))}
                            </tbody>
                        </Table>
                        <PaginationWrapper
                          setPage={setPage}
                          page={page}
                          dataCount={data && Math.ceil(data.count / 25)}
                        />
                    </Column>
                </Columns>
            </details>
        </Box>
    );


}